<template>
  <div>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div v-if="checkType(itemFile) == 'image'" class="h-50 p-2">
        <img :src="itemFile.file_path ? itemFile.file_path : itemFile.file_local" class="img-fluid">
      </div>
      <div v-else-if="checkType(itemFile) == 'video'" class="video p-1">
        <video width="100%" poster="/img/poster.gif" :src="itemFile.file_path ? itemFile.file_path : itemFile.file_local"
          autoplay controls type="video/*" />
      </div>
      <div v-else class="video p-1">
        <audio :src="itemFile.file_path ? itemFile.file_path : itemFile.file_local" autoplay controls type="audio/*"
          controlslist="nodownload noplaybackrate" with="100%" />
      </div>
    </b-overlay>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BImg, BButton, BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BButton,
    BOverlay,
  },
  props: {
    itemFile: {
      type: Object,
      default: null,
    },
  },
  setup(props, context) {
    // const link = ref('')
    // const extension = ref('')
    const loading = ref(false)
    // const file_id = ref('')
    // if (Object.keys(props.dataImage).length > 0) {
    //   // link.value = props.dataImage.full_path ? props.dataImage.full_path : props.dataImage.response.data.full_path
    //   link.value = props.dataImage.full_path ? props.dataImage.full_path : props.dataImage.file_local
    //   extension.value = props.dataImage.extension
    //   file_id.value = props.dataImage.file_id ? props.dataImage.file_id : props.dataImage.id
    //   // console.log('extension', extension.value)
    // }
    const checkType = (file) => {
      let arr = file.mimetype.split('/');

      return arr[0]
    }
    return {
      // link,
      loading,
      // extension,
      // file_id,
      checkType
    }
  },
}
</script>
<style lang="scss">
.video {
  audio {
    width: 100%;
  }
}
</style>
